import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteHomeSection } from "../../api/apiHomeSections";
import { toast } from "react-hot-toast";

export const useDeleteHomeSection = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteSectionMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteHomeSection,
        onSuccess: (res) => {
            toast.success(res.message);
            queryClient.invalidateQueries(["home-sections"]);
        },
        onError: (error) => {
            console.error("Error deleting home section:", error);
            toast.error(error.response?.data?.message || ("Error deleting home section"));
        },
    });

    return { deleteSectionMutate, isDeleting };
};
